import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, Window508Type } from "../CalmBaseScenario";
import Scenario2 from "./Scenario2";
import { IonItemOptions } from "@ionic/react";

export default class Scenario2Part4 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;

	chapterIds = {		
		scenario2_1b_s13: 'CALM - Scenario 2 - 2B - Segment 13'
	}

	constructor(scenario: Scenario2, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part4.id;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario2/calm-scenario2-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public start() {
		const context = this;
		context.segment1Step1JamieApproaches();
	}

	private segment1Step1JamieApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Receive update from LPN Jamie');
		this.playVideoChapter(this.chapterIds.scenario2_1b_s13, () => {
			context.scenario.updateObjective('');
			context.showNurseStationComputer();
		});
	}		

	private showNurseStationComputer() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'In this scenario of a patient needing information on diabetes, there was no patient event. No data is added to this report.'
				},
				{
					title: '24 Hour',
					description: 'In this scenario of a patient needing information on diabetes, there was no patient event. No data is added to this report.'
				},
				{
					title: 'End of Shift',
					description: 'In this scenario of a patient needing information on diabetes, there was no patient event. No data is added to this report.'
				}
			],
			review: {
				text:
					`
				<p class="regular-description-font" style="margin: 0;">
				As a Charge Nurse, it is your duty to <span style="color: rgb(222, 225, 156)">advise your staff</span> on how best to care for their patients. Often, 
				you will have to <span style="color: rgb(222, 225, 156)">think critically</span> about how best to do this. <br /><br />
				In this case, you had to determine the appropriate level of patient education needed for this Type II diabetes patient. Because this was the 
				patient’s third admission in recent times, he was likely provided some high-level educational materials 
				about the disease already. It was determined that a personalized approach, through the means of a diabetic 
				education consult, would be the best option. However, it is important to <span style="color: rgb(222, 225, 156)">ensure that all possible patient 
				education avenues are explored</span>. There are many credible resources that the patient could have been directed 
				to, <span style="color: rgb(222, 225, 156)">both online and in the hospital</span>. <br /><br />
				Patients are also <span style="color: rgb(222, 225, 156)">encouraged to consult with their primary care physicians</span> 
				to learn more about their conditions. Furthermore, all Veterans should be encouraged to sign up for My <span style="color: rgb(222, 225, 156)">HealtheVet</span>,
				 a great resource to teach them about their conditions and how to mitigate risk factors. Lastly, diabetic educators 
				 can provide a much more individualized approach, if needed.  
				</p>
				`
			},
			reflects: [
				{
					title: 'What are some educational resources that your facility offers? ',
					answer: ''
				},
				{
					title: 'How could you determine the educational need of a particular patient?',
					answer: ''
				},
				{
					title: 'How can you best advise your staff to provide the highest level of education to your patients?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}
 
	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			var badges = context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].badges;
			for(var indx = 0; indx < badges.length; indx++) {
				badges[indx].isUnlocked = true;
			}
			context.scenario.gameManager.UiManager.destroyAllInstances();
			context.scenario.unlockNextLevel();
			context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = null;
			context.scenario.update508Window(Window508Type.EndLevelUI);
			context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.EndLevelUI, {
				level: context.scenario.currentLevel,
				badges: badges,
				onExitGameClicked: () => {
					context.scenario.exitGame();
				},
				onNextLevelClicked: () => {
					context.scenario.nextLevel();
					context.onDone();
				}
			});
		});
	}
}